// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-grid-fluid, .c-grid {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
}

/*/
 * Hamburgers
 * @description Tasty CSS-animated hamburgers
 * @author Jonathan Suh @jonsuh
 * @site https://jonsuh.com/hamburgers
 * @link https://github.com/jonsuh/hamburgers
 */
.hamburger {
  padding: 0 0;
  display: flex;
  cursor: pointer;
  transition-property: opacity, filter;
  transition-duration: 0.35s;
  transition-timing-function: linear;
  font: inherit;
  color: inherit;
  text-transform: none;
  background-color: transparent;
  border: 0;
  margin: 0;
  overflow: visible;
}
.hamburger:hover {
  opacity: 0.7;
}

.hamburger-box {
  width: 30px;
  height: 16px;
  display: inline-block;
  position: relative;
}

.hamburger-inner {
  display: block;
  top: 50%;
  margin-top: -1px;
}
.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {
  width: 30px;
  height: 2px;
  background-color: #fff;
  border-radius: 4px;
  position: absolute;
  transition-property: transform;
  transition-duration: 0.15s;
  transition-timing-function: ease;
}
.hamburger-inner::before, .hamburger-inner::after {
  content: "";
  display: block;
}
.hamburger-inner::before {
  top: -7px;
}
.hamburger-inner::after {
  bottom: -7px;
}

/*
 * Squeeze
 */
.hamburger--squeeze .hamburger-inner {
  transition-duration: 0.075s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.hamburger--squeeze .hamburger-inner::before {
  transition: top 0.075s 0.12s ease, opacity 0.075s ease;
}
.hamburger--squeeze .hamburger-inner::after {
  transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);
}
.hamburger--squeeze.is-active .hamburger-inner {
  transform: rotate(45deg);
  transition-delay: 0.12s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
}
.hamburger--squeeze.is-active .hamburger-inner::before {
  top: 0;
  opacity: 0;
  transition: top 0.075s ease, opacity 0.075s 0.12s ease;
}
.hamburger--squeeze.is-active .hamburger-inner::after {
  bottom: 0;
  transform: rotate(-90deg);
  transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);
}

html,
body {
  width: 100%;
  min-height: 100vh;
}
html.is-hideScroll,
body.is-hideScroll {
  overflow: hidden !important;
  width: 100%;
}

html {
  -ms-overflow-style: scrollbar;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

body {
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0px 0 0;
  background-color: #10113A;
  line-height: 1.42857143;
  /*font-size: 14px;*/
  /*font-weight: normal;*/
  /*font-family: "Proxima Nova", sans-serif;*/
  /*  font-family: "arial", sans-serif;*/
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
body > .main {
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1 0 auto;
}
body > .main--start {
  justify-content: flex-start;
}

* {
  box-sizing: border-box;
}
*:before, *:after {
  box-sizing: border-box;
}

button,
input,
optgroup,
select,
textarea {
  font-size: 100%;
  margin: 0;
}

button,
input {
  overflow: visible;
}

button[disabled] {
  opacity: 0.55;
  cursor: not-allowed;
}

[type=search] {
  -webkit-appearance: textfield;
  outline-offset: -2px;
}

[type=search]::-webkit-search-cancel-button,
[type=search]::-webkit-search-decoration {
  -webkit-appearance: none;
}

textarea {
  overflow: auto;
}

p,
h1, h2, h3, h4, h5, h6,
hr {
  margin: 0;
  padding: 0;
}

ul {
  margin: 0;
  padding: 0;
}
ul li {
  list-style: none;
}

a {
  outline: none;
  text-decoration: none;
}
a:hover, a:focus {
  text-decoration: none;
}

input[type=text] {
  appearance: none;
}

picture {
  display: flex;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.c-grid {
  max-width: 1340px;
  padding-right: 30px;
  padding-left: 30px;
}
.c-grid-fluid {
  max-width: 100%;
  padding-right: 30px;
  padding-left: 30px;
}

.c-form {
  display: flex;
  flex-direction: column;
}
.c-form__group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
}
@media screen and (max-width: 767px) {
  .c-form__group {
    grid-template-columns: 1fr;
  }
}
.c-form__group .c-form__field {
  margin-bottom: 23px;
}
.c-form__field {
  display: flex;
  flex-direction: column;
}
.c-form__field.c-form__field--link a {
  display: flex;
  color: rgba(26, 26, 26, 0.61);
  font-size: 12px;
  text-decoration-line: underline;
}
.c-form__field.c-form__field--btn {
  width: 100%;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}
.c-form__field + .sign__link {
  transform: translateY(-15px);
}
.c-form__field:not(:last-of-type) {
  margin-bottom: 23px;
}
@media screen and (max-width: 767px) {
  .c-form__field .c-btn__wrapper {
    flex-direction: column;
  }
  .c-form__field .c-btn__wrapper .c-btn + .c-btn {
    margin-left: 0;
    margin-top: 12px;
  }
}
.c-form__label {
  padding-bottom: 8px;
  color: #1A1A1A;
  font-size: 14px;
}
.c-form__input {
  outline: none;
  position: relative;
  width: 100%;
  height: 32px;
  padding: 9px;
  border-radius: 8px;
  border: none;
  box-shadow: none;
  background: rgba(0, 0, 0, 0.04);
  color: #000000;
  font-size: 12px;
}
.c-form__input.placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
}
.c-form__input:-moz-placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
}
.c-form__input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
}
.c-form__input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
}
.c-form__input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
}

.c-section {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 480px;
  padding: 37px 40px;
  border-radius: 12px;
  background-color: #FFF;
}
@media screen and (max-width: 767px) {
  .c-section {
    padding: 30px 20px;
  }
}
.c-section[data-align=center] {
  margin-left: auto;
  margin-right: auto;
}
.c-section[data-size=big] {
  max-width: 800px;
}
.c-section[data-size=xbig] {
  max-width: 1000px;
}
.c-section__head {
  padding-bottom: 25px;
  margin-bottom: 25px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.04);
}
.c-section__footer {
  padding-top: 25px;
  margin-top: 25px;
  border-top: 1px solid rgba(0, 0, 0, 0.04);
}
.c-section__title {
  padding-bottom: 10px;
  color: rgba(0, 0, 0, 0.95);
  font-size: 20px;
  font-weight: 700;
}
.c-section__desc {
  padding-bottom: 20px;
  color: rgba(26, 26, 26, 0.61);
  font-size: 14px;
}
.c-section__desc strong {
  font-weight: 700;
}
.c-section__info {
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  font-weight: 400;
}
.c-section__info a {
  color: #3A00FF;
}

.c-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding-left: 10px;
  padding-right: 10px;
}
@media screen and (max-width: 767px) {
  .c-pagination {
    gap: 5px;
    padding-left: 5px;
    padding-right: 5px;
  }
}
.c-pagination__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
@media screen and (max-width: 767px) {
  .c-pagination__wrapper {
    gap: 5px;
  }
}
.c-pagination__btn, .c-pagination__link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #fff;
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
  .c-pagination__btn, .c-pagination__link {
    width: 35px;
    height: 35px;
    font-size: 16px;
  }
}
.c-pagination__btn:hover, .c-pagination__link:hover {
  background-color: #fff;
  color: #000000;
  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.c-pagination__btn:hover svg path, .c-pagination__link:hover svg path {
  fill: #000000 !important;
  transition: fill 0.3s ease-in-out;
}
.c-pagination__btn {
  border-color: #fff;
}
.c-pagination__btn svg {
  display: block;
  width: 18px;
  height: 18px;
}
@media screen and (max-width: 767px) {
  .c-pagination__btn svg {
    width: 16px;
    height: 16px;
  }
}
.c-pagination__btn svg path {
  transition: fill 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
  .c-pagination__btn.is-first, .c-pagination__btn.is-last {
    display: none;
  }
}
.c-pagination__btn.is-last svg, .c-pagination__btn.is-next svg {
  transform: rotate(180deg);
}
.c-pagination__link:hover, .c-pagination__link.is-active {
  border-color: #3A00FF;
  background-color: #3A00FF;
  color: #fff;
}
.c-pagination__link.is-disabled {
  pointer-events: none;
  border: none;
}

.logo {
  display: flex;
  align-items: flex-start;
}
.logo__link {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 1279px) {
  .logo__link {
    max-width: 225px;
  }
}
@media screen and (max-width: 767px) {
  .logo__link {
    max-width: 150px;
  }
}
.logo__image {
  display: block;
  max-width: 100%;
  height: auto;
}

.c-btn {
  outline: none;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: 40px;
  padding-left: 24px;
  padding-right: 24px;
  border-radius: 20px;
  border: none;
  box-shadow: none;
  background-color: #F3B610;
  color: #F8F8F8;
  font-size: 15px;
  font-weight: 500;
  line-height: 15px;
  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
@media screen and (max-width: 767px) {
  .c-btn {
    padding-left: 14px;
    padding-right: 14px;
    font-size: 14px;
  }
}
.c-btn:hover {
  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out;
}
.c-btn.c-btn--with {
  border: 1px solid rgba(0, 0, 0, 0.75);
  background-color: transparent;
  color: #000000;
}
.c-btn[data-btn-size=full] {
  width: 100%;
}
.c-btn[data-btn-color=gray] {
  background-color: #F5F5F5;
  color: #1A1A1A;
}
.c-btn[data-btn-color=gray]:hover {
  background-color: #3A00FF;
  color: #ffffff;
}
.c-btn[data-btn-color=blue] {
  box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0.3);
  background-color: #3A00FF;
  color: #fff;
}
.c-btn[data-btn-color=blue]:disabled,
.c-btn[data-btn-color=blue]:hover {
  box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0);
  background-color: #F5F5F5;
  color: #1A1A1A;
}
.c-btn[data-btn-fw="600"] {
  font-weight: 600;
}
.c-btn[data-btn-round=half] {
  border-radius: 10px;
}
.c-btn + .c-btn {
  margin-left: 12px;
}
.c-btn__wrapper {
  display: flex;
  align-items: center;
}
.c-btn__wrapper--column {
  flex-direction: column;
}
.c-btn__wrapper--column .c-btn + .c-btn {
  margin-left: 0;
  margin-top: 12px;
}
.c-btn__wrapper--center {
  justify-content: center;
}
.c-btn__wrapper--between {
  justify-content: space-between;
}

.header {
  z-index: 999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: rgba(4, 4, 30, 0.32);
}
.header__wrapper {
  display: grid;
  grid-template-columns: 300px 1fr 300px;
  align-items: center;
  gap: 30px;
  height: 90px;
}
@media screen and (max-width: 1279px) {
  .header__wrapper {
    grid-template-columns: 225px 1fr 225px;
  }
}
@media screen and (max-width: 1023px) {
  .header__wrapper {
    display: flex;
    justify-content: space-between;
  }
}
.header__wrapper > div:nth-of-type(2) {
  display: flex;
  justify-content: center;
}
@media screen and (max-width: 1023px) {
  .header__wrapper > div:nth-of-type(2) {
    z-index: 999;
    overflow: hidden;
    overflow-y: auto;
    position: fixed;
    top: 90px;
    left: 0;
    display: none;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100% - 90px);
    padding: 50px;
    background-color: #04041e;
  }
  .header__wrapper > div:nth-of-type(2).is-open {
    display: flex;
  }
}
.header__wrapper > div:nth-of-type(3) {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
@media screen and (max-width: 1023px) {
  .header__wrapper > div:nth-of-type(3) {
    gap: 15px;
  }
}
.header__wrapper > div:nth-of-type(3) .hamburger {
  display: none;
}
@media screen and (max-width: 1023px) {
  .header__wrapper > div:nth-of-type(3) .hamburger {
    display: flex;
  }
}
.header__nav {
  display: flex;
  align-items: center;
  column-gap: 50px;
}
@media screen and (max-width: 1279px) {
  .header__nav {
    column-gap: 20px;
  }
}
@media screen and (max-width: 1023px) {
  .header__nav {
    flex-direction: column;
    gap: 30px;
  }
}
.header__nav a {
  display: flex;
  color: #F8F8F8;
  font-size: 16px;
  font-weight: 400;
}
@media screen and (max-width: 1023px) {
  .header__nav a {
    font-size: 20px;
  }
}

.subscribe {
  padding-top: 152px;
  padding-bottom: 152px;
}
@media screen and (max-width: 767px) {
  .subscribe {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.subscribe__box {
  display: flex;
  flex-direction: column;
  padding: 17px 26px;
  border-radius: 8px;
  border: 1px solid #EBEBEB;
  text-align: center;
}
.subscribe__box-wrapper {
  display: grid;
  align-items: flex-start;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  padding-top: 54px;
  padding-bottom: 24px;
}
@media screen and (max-width: 767px) {
  .subscribe__box-wrapper {
    grid-template-columns: 1fr;
  }
}
.subscribe__box-title {
  padding-bottom: 10px;
  color: #1A1A1A;
  font-size: 20px;
  font-weight: 700;
}
.subscribe__box-desc {
  padding-bottom: 15px;
  color: rgba(26, 26, 26, 0.61);
  text-align: center;
  font-size: 12px;
}
.subscribe__box-subtitle {
  padding-bottom: 15px;
  color: #1A1A1A;
  text-align: center;
  font-size: 16px;
  font-weight: 700;
}
.subscribe__box-subtitle-wrapper > div {
  display: flex;
}
.subscribe__box-subtitle-wrapper > div label {
  display: flex;
  align-items: flex-start;
  padding-top: 4px;
  padding-right: 10px;
}
.subscribe__box-subtitle-wrapper > div > div {
  flex: 1 1;
}
.subscribe__box-subtitle + .subscribe__box-subtitle {
  padding-top: 15px;
  border-top: 1px solid #EBEBEB;
}
.subscribe__box-subtitle span {
  color: rgba(26, 26, 26, 0.61);
  text-align: center;
  font-size: 12px;
  font-weight: 400;
}

.sign {
  padding-top: 152px;
}
@media screen and (max-width: 767px) {
  .sign {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}
.sign__with .c-btn {
  width: 100%;
}
.sign__with .c-btn img + span {
  padding-left: 12px;
}
.sign__or {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 24px;
  padding-bottom: 24px;
}
.sign__or:before {
  content: "";
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  left: 0;
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.12);
}
.sign__or span {
  z-index: 2;
  position: relative;
  background-color: #ffffff;
  padding-left: 10px;
  padding-right: 10px;
}
.sign__link {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 15px;
}
.sign__link a {
  margin-left: 3px;
  color: #3A00FF;
}

.check-your-email {
  padding-top: 152px;
  padding-bottom: 152px;
}
@media screen and (max-width: 767px) {
  .check-your-email {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}

.thank-you {
  padding-top: 152px;
  padding-bottom: 152px;
}
@media screen and (max-width: 767px) {
  .thank-you {
    padding-top: 100px;
    padding-bottom: 100px;
  }
}

.statistics {
  padding-top: 75px;
  padding-bottom: 100px;
}
@media screen and (max-width: 767px) {
  .statistics {
    padding-top: 50px;
    padding-bottom: 50px;
  }
}
.statistics__wrapper-header {
  display: flex;
  justify-content: flex-end;
  padding-bottom: 76px;
  gap: 30px;
}
@media screen and (max-width: 767px) {
  .statistics__wrapper-header {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding-bottom: 50px;
  }
}
.statistics__wrapper-footer {
  padding-top: 76px;
}
@media screen and (max-width: 767px) {
  .statistics__wrapper-footer {
    padding-top: 50px;
  }
}
.statistics__total {
  display: flex;
  align-items: center;
}
.statistics__total p {
  color: #ffffff;
  font-size: 18px;
}
.statistics__total p strong {
  font-weight: 700;
}
.statistics__date {
  display: flex;
  width: 100%;
  max-width: 300px;
}
@media screen and (max-width: 767px) {
  .statistics__date {
    max-width: 100%;
  }
}
.statistics__date label {
  display: flex;
  width: 100%;
}
.statistics__date label input {
  outline: none;
  position: relative;
  width: 100%;
  height: 32px;
  padding: 9px;
  border-radius: 8px;
  border: none;
  box-shadow: none;
  background: #fff;
  color: #000000;
  font-size: 14px;
}
.statistics__table {
  padding: 10px;
  border-radius: 12px;
  background-color: rgba(255, 255, 255, 0.95);
}
@media screen and (max-width: 1599px) {
  .statistics__table {
    overflow: hidden;
    overflow-x: auto;
    position: relative;
    width: calc(100% + 30px);
    border-radius: 12px 0 0 12px;
  }
}
.statistics__table table {
  width: 100%;
  max-width: 100%;
  border-collapse: collapse;
  background-color: transparent;
}
@media screen and (max-width: 1599px) {
  .statistics__table table {
    width: 1700px;
    max-width: unset;
  }
}
.statistics__table table tbody tr {
  transition: background-color 0.3s ease-in-out;
}
.statistics__table table tbody tr:hover {
  background: rgba(0, 0, 0, 0.04);
  transition: background-color 0.3s ease-in-out;
}
.statistics__table table tr th,
.statistics__table table tr td {
  vertical-align: middle;
  text-align: left;
  padding: 0.75rem;
  color: #000;
}
.statistics__table table tr th {
  border-bottom: 2px solid #dee2e6;
  border-bottom-width: 2px;
  font-weight: 600;
  font-size: 15px;
}
.statistics__table table tr th.center {
  text-align: center;
}
.statistics__table table tr td {
  font-size: 14px;
  border-bottom: 1px solid #dee2e6;
}
.statistics__table table tr td:first-of-type {
  font-weight: 600;
}
.statistics__table table tr td a {
  color: #3A00FF;
}
.statistics__table table tr td span {
  display: block;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/pages/Register/css/app.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;;;;;EAME;AACF;EACE,YAAY;EAGZ,aAAa;EACb,eAAe;EAGf,oCAAoC;EAG5B,0BAA0B;EAE1B,kCAAkC;EAC1C,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;EACT,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAGlB,8BAA8B;EAGtB,0BAA0B;EAE1B,gCAAgC;AAC1C;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,SAAS;AACX;AACA;EACE,YAAY;AACd;;AAEA;;EAEE;AACF;EAEU,2BAA2B;EAE3B,kEAAkE;AAC5E;AACA;EAEE,sDAAsD;AACxD;AACA;EAGE,6FAA6F;AAE/F;AACA;EAGU,wBAAwB;EAExB,uBAAuB;EAEvB,+DAA+D;AACzE;AACA;EACE,MAAM;EACN,UAAU;EAEV,sDAAsD;AACxD;AACA;EACE,SAAS;EAGD,yBAAyB;EAGjC,0FAA0F;AAE5F;;AAEA;;EAEE,WAAW;EACX,iBAAiB;AACnB;AACA;;EAEE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAGlB,aAAa;EAIL,sBAAsB;EAC9B,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,2CAA2C;EAC3C,sCAAsC;EACtC,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EAGE,aAAa;EAIL,sBAAsB;EAGtB,uBAAuB;EAGvB,cAAc;AACxB;AACA;EAGU,2BAA2B;AACrC;;AAEA;EAEU,sBAAsB;AAChC;AACA;EAEU,sBAAsB;AAChC;;AAEA;;;;;EAKE,eAAe;EACf,SAAS;AACX;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;;AAEA;EAGU,gBAAgB;AAC1B;;AAEA;EAGE,aAAa;EACb,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAGE,aAAa;EAIL,sBAAsB;AAChC;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,mBAAmB;AACrB;AACA;EAGE,aAAa;EAIL,sBAAsB;AAChC;AACA;EAGE,aAAa;EACb,6BAA6B;EAC7B,eAAe;EACf,+BAA+B;AACjC;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EAGU,4BAA4B;AACtC;AACA;EACE,mBAAmB;AACrB;AACA;EACE;IAIU,sBAAsB;EAChC;EACA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EAEJ,gBAAgB;EACxB,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EAGE,aAAa;EAIL,sBAAsB;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE;IACE,kBAAkB;EACpB;AACF;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;AACA;EACE,oBAAoB;EACpB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE;IACE,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;EACpB;AACF;AACA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,SAAS;AACX;AACA;EACE;IACE,QAAQ;EACV;AACF;AACA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAEhB,qEAAqE;AACvE;AACA;EACE;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;EAEd,qEAAqE;AACvE;AACA;EACE,wBAAwB;EAExB,iCAAiC;AACnC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;AACA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;AACA;EAEE,iCAAiC;AACnC;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EAGU,yBAAyB;AACnC;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,YAAY;AACd;;AAEA;EAGE,aAAa;EAGL,uBAAuB;AACjC;AACA;EAGE,aAAa;EAGL,mBAAmB;AAC7B;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,kBAAkB;EAGlB,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EAEJ,gBAAgB;EACxB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EAGjB,kGAAkG;AAEpG;AACA;EACE;IACE,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;EACjB;AACF;AACA;EAGE,kGAAkG;AAEpG;AACA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EAEU,mDAAmD;EAC3D,yBAAyB;EACzB,WAAW;AACb;AACA;;EAGU,iDAAiD;EACzD,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EAGE,aAAa;EAGL,mBAAmB;AAC7B;AACA;EAIU,sBAAsB;AAChC;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EAGU,uBAAuB;AACjC;AACA;EAGU,8BAA8B;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,sCAAsC;EAG9B,mBAAmB;EAC3B,SAAS;EACT,YAAY;AACd;AACA;EACE;IACE,sCAAsC;EACxC;AACF;AACA;EACE;IAGE,aAAa;IAGL,8BAA8B;EACxC;AACF;AACA;EAGE,aAAa;EAGL,uBAAuB;AACjC;AACA;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,OAAO;IACP,aAAa;IAGL,mBAAmB;IAGnB,uBAAuB;IAC/B,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,yBAAyB;EAC3B;EACA;IAGE,aAAa;EACf;AACF;AACA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,yBAAyB;AACnC;AACA;EACE;IACE,SAAS;EACX;AACF;AACA;EACE,aAAa;AACf;AACA;EACE;IAGE,aAAa;EACf;AACF;AACA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,gBAAgB;AAC1B;AACA;EACE;IAGU,gBAAgB;EAC1B;AACF;AACA;EACE;IAIU,sBAAsB;IAC9B,SAAS;EACX;AACF;AACA;EAGE,aAAa;EACb,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA;EAGE,aAAa;EAIL,sBAAsB;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,aAAa;EAGL,uBAAuB;EAC/B,qCAAqC;EACrC,SAAS;EACT,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;AACA;EAGE,aAAa;AACf;AACA;EAGE,aAAa;EAGL,uBAAuB;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EAGU,SAAO;AACjB;AACA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAGlB,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAGA,2BAA2B;EACnC,OAAO;EACP,WAAW;EACX,WAAW;EACX,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EAGE,aAAa;EAGL,mBAAmB;EAGnB,uBAAuB;EAC/B,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE;IACE,kBAAkB;IAClB,qBAAqB;EACvB;AACF;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE;IACE,iBAAiB;IACjB,oBAAoB;EACtB;AACF;AACA;EAGE,aAAa;EAGL,yBAAyB;EACjC,oBAAoB;EACpB,SAAS;AACX;AACA;EACE;IAIU,sBAAsB;IAGtB,mBAAmB;IAGnB,uBAAuB;IAC/B,kBAAkB;IAClB,oBAAoB;EACtB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EAGE,aAAa;EAGL,mBAAmB;AAC7B;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EAGE,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EAEJ,gBAAgB;EACxB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;AACA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;AACA;EAEE,6CAA6C;AAC/C;AACA;EACE,+BAA+B;EAE/B,6CAA6C;AAC/C;AACA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB","sourcesContent":[".c-grid-fluid, .c-grid {\n  width: 100%;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n/*/\n * Hamburgers\n * @description Tasty CSS-animated hamburgers\n * @author Jonathan Suh @jonsuh\n * @site https://jonsuh.com/hamburgers\n * @link https://github.com/jonsuh/hamburgers\n */\n.hamburger {\n  padding: 0 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  -webkit-transition-property: opacity, -webkit-filter;\n  transition-property: opacity, -webkit-filter;\n  transition-property: opacity, filter;\n  transition-property: opacity, filter, -webkit-filter;\n  -webkit-transition-duration: 0.35s;\n          transition-duration: 0.35s;\n  -webkit-transition-timing-function: linear;\n          transition-timing-function: linear;\n  font: inherit;\n  color: inherit;\n  text-transform: none;\n  background-color: transparent;\n  border: 0;\n  margin: 0;\n  overflow: visible;\n}\n.hamburger:hover {\n  opacity: 0.7;\n}\n\n.hamburger-box {\n  width: 30px;\n  height: 16px;\n  display: inline-block;\n  position: relative;\n}\n\n.hamburger-inner {\n  display: block;\n  top: 50%;\n  margin-top: -1px;\n}\n.hamburger-inner, .hamburger-inner::before, .hamburger-inner::after {\n  width: 30px;\n  height: 2px;\n  background-color: #fff;\n  border-radius: 4px;\n  position: absolute;\n  -webkit-transition-property: -webkit-transform;\n  transition-property: -webkit-transform;\n  transition-property: transform;\n  transition-property: transform, -webkit-transform;\n  -webkit-transition-duration: 0.15s;\n          transition-duration: 0.15s;\n  -webkit-transition-timing-function: ease;\n          transition-timing-function: ease;\n}\n.hamburger-inner::before, .hamburger-inner::after {\n  content: \"\";\n  display: block;\n}\n.hamburger-inner::before {\n  top: -7px;\n}\n.hamburger-inner::after {\n  bottom: -7px;\n}\n\n/*\n * Squeeze\n */\n.hamburger--squeeze .hamburger-inner {\n  -webkit-transition-duration: 0.075s;\n          transition-duration: 0.075s;\n  -webkit-transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n          transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--squeeze .hamburger-inner::before {\n  -webkit-transition: top 0.075s 0.12s ease, opacity 0.075s ease;\n  transition: top 0.075s 0.12s ease, opacity 0.075s ease;\n}\n.hamburger--squeeze .hamburger-inner::after {\n  -webkit-transition: bottom 0.075s 0.12s ease, -webkit-transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.075s 0.12s ease, -webkit-transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n  transition: bottom 0.075s 0.12s ease, transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19), -webkit-transform 0.075s cubic-bezier(0.55, 0.055, 0.675, 0.19);\n}\n.hamburger--squeeze.is-active .hamburger-inner {\n  -webkit-transform: rotate(45deg);\n      -ms-transform: rotate(45deg);\n          transform: rotate(45deg);\n  -webkit-transition-delay: 0.12s;\n          transition-delay: 0.12s;\n  -webkit-transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n          transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n.hamburger--squeeze.is-active .hamburger-inner::before {\n  top: 0;\n  opacity: 0;\n  -webkit-transition: top 0.075s ease, opacity 0.075s 0.12s ease;\n  transition: top 0.075s ease, opacity 0.075s 0.12s ease;\n}\n.hamburger--squeeze.is-active .hamburger-inner::after {\n  bottom: 0;\n  -webkit-transform: rotate(-90deg);\n      -ms-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n  -webkit-transition: bottom 0.075s ease, -webkit-transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: bottom 0.075s ease, -webkit-transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n  transition: bottom 0.075s ease, transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1), -webkit-transform 0.075s 0.12s cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\nhtml,\nbody {\n  width: 100%;\n  min-height: 100vh;\n}\nhtml.is-hideScroll,\nbody.is-hideScroll {\n  overflow: hidden !important;\n  width: 100%;\n}\n\nhtml {\n  -ms-overflow-style: scrollbar;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\nbody {\n  overflow-x: hidden;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  margin: 0;\n  padding: 0px 0 0;\n  background-color: #10113A;\n  line-height: 1.42857143;\n  /*font-size: 14px;*/\n  /*font-weight: normal;*/\n  /*font-family: \"Proxima Nova\", sans-serif;*/\n  /*  font-family: \"arial\", sans-serif;*/\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nbody > .main {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 0 auto;\n          flex: 1 0 auto;\n}\nbody > .main--start {\n  -webkit-box-pack: start;\n      -ms-flex-pack: start;\n          justify-content: flex-start;\n}\n\n* {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n*:before, *:after {\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font-size: 100%;\n  margin: 0;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton[disabled] {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n[type=search] {\n  -webkit-appearance: textfield;\n  outline-offset: -2px;\n}\n\n[type=search]::-webkit-search-cancel-button,\n[type=search]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\ntextarea {\n  overflow: auto;\n}\n\np,\nh1, h2, h3, h4, h5, h6,\nhr {\n  margin: 0;\n  padding: 0;\n}\n\nul {\n  margin: 0;\n  padding: 0;\n}\nul li {\n  list-style: none;\n}\n\na {\n  outline: none;\n  text-decoration: none;\n}\na:hover, a:focus {\n  text-decoration: none;\n}\n\ninput[type=text] {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\npicture {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.c-grid {\n  max-width: 1340px;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n.c-grid-fluid {\n  max-width: 100%;\n  padding-right: 30px;\n  padding-left: 30px;\n}\n\n.c-form {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.c-form__group {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n}\n@media screen and (max-width: 767px) {\n  .c-form__group {\n    grid-template-columns: 1fr;\n  }\n}\n.c-form__group .c-form__field {\n  margin-bottom: 23px;\n}\n.c-form__field {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.c-form__field.c-form__field--link a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: rgba(26, 26, 26, 0.61);\n  font-size: 12px;\n  text-decoration-line: underline;\n}\n.c-form__field.c-form__field--btn {\n  width: 100%;\n  max-width: 400px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.c-form__field + .sign__link {\n  -webkit-transform: translateY(-15px);\n      -ms-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.c-form__field:not(:last-of-type) {\n  margin-bottom: 23px;\n}\n@media screen and (max-width: 767px) {\n  .c-form__field .c-btn__wrapper {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n  }\n  .c-form__field .c-btn__wrapper .c-btn + .c-btn {\n    margin-left: 0;\n    margin-top: 12px;\n  }\n}\n.c-form__label {\n  padding-bottom: 8px;\n  color: #1A1A1A;\n  font-size: 14px;\n}\n.c-form__input {\n  outline: none;\n  position: relative;\n  width: 100%;\n  height: 32px;\n  padding: 9px;\n  border-radius: 8px;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background: rgba(0, 0, 0, 0.04);\n  color: #000000;\n  font-size: 12px;\n}\n.c-form__input.placeholder {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 12px;\n}\n.c-form__input:-moz-placeholder {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 12px;\n}\n.c-form__input::-moz-placeholder {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 12px;\n}\n.c-form__input:-ms-input-placeholder {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 12px;\n}\n.c-form__input::-webkit-input-placeholder {\n  color: rgba(0, 0, 0, 0.35);\n  font-size: 12px;\n}\n\n.c-section {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  width: 100%;\n  max-width: 480px;\n  padding: 37px 40px;\n  border-radius: 12px;\n  background-color: #FFF;\n}\n@media screen and (max-width: 767px) {\n  .c-section {\n    padding: 30px 20px;\n  }\n}\n.c-section[data-align=center] {\n  margin-left: auto;\n  margin-right: auto;\n}\n.c-section[data-size=big] {\n  max-width: 800px;\n}\n.c-section[data-size=xbig] {\n  max-width: 1000px;\n}\n.c-section__head {\n  padding-bottom: 25px;\n  margin-bottom: 25px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n}\n.c-section__footer {\n  padding-top: 25px;\n  margin-top: 25px;\n  border-top: 1px solid rgba(0, 0, 0, 0.04);\n}\n.c-section__title {\n  padding-bottom: 10px;\n  color: rgba(0, 0, 0, 0.95);\n  font-size: 20px;\n  font-weight: 700;\n}\n.c-section__desc {\n  padding-bottom: 20px;\n  color: rgba(26, 26, 26, 0.61);\n  font-size: 14px;\n}\n.c-section__desc strong {\n  font-weight: 700;\n}\n.c-section__info {\n  color: rgba(0, 0, 0, 0.5);\n  font-size: 12px;\n  font-weight: 400;\n}\n.c-section__info a {\n  color: #3A00FF;\n}\n\n.c-pagination {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 10px;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n@media screen and (max-width: 767px) {\n  .c-pagination {\n    gap: 5px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n}\n.c-pagination__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  gap: 10px;\n}\n@media screen and (max-width: 767px) {\n  .c-pagination__wrapper {\n    gap: 5px;\n  }\n}\n.c-pagination__btn, .c-pagination__link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 1px solid #fff;\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n  -webkit-transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n}\n@media screen and (max-width: 767px) {\n  .c-pagination__btn, .c-pagination__link {\n    width: 35px;\n    height: 35px;\n    font-size: 16px;\n  }\n}\n.c-pagination__btn:hover, .c-pagination__link:hover {\n  background-color: #fff;\n  color: #000000;\n  -webkit-transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n}\n.c-pagination__btn:hover svg path, .c-pagination__link:hover svg path {\n  fill: #000000 !important;\n  -webkit-transition: fill 0.3s ease-in-out;\n  transition: fill 0.3s ease-in-out;\n}\n.c-pagination__btn {\n  border-color: #fff;\n}\n.c-pagination__btn svg {\n  display: block;\n  width: 18px;\n  height: 18px;\n}\n@media screen and (max-width: 767px) {\n  .c-pagination__btn svg {\n    width: 16px;\n    height: 16px;\n  }\n}\n.c-pagination__btn svg path {\n  -webkit-transition: fill 0.3s ease-in-out;\n  transition: fill 0.3s ease-in-out;\n}\n@media screen and (max-width: 767px) {\n  .c-pagination__btn.is-first, .c-pagination__btn.is-last {\n    display: none;\n  }\n}\n.c-pagination__btn.is-last svg, .c-pagination__btn.is-next svg {\n  -webkit-transform: rotate(180deg);\n      -ms-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.c-pagination__link:hover, .c-pagination__link.is-active {\n  border-color: #3A00FF;\n  background-color: #3A00FF;\n  color: #fff;\n}\n.c-pagination__link.is-disabled {\n  pointer-events: none;\n  border: none;\n}\n\n.logo {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n}\n.logo__link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n@media screen and (max-width: 1279px) {\n  .logo__link {\n    max-width: 225px;\n  }\n}\n@media screen and (max-width: 767px) {\n  .logo__link {\n    max-width: 150px;\n  }\n}\n.logo__image {\n  display: block;\n  max-width: 100%;\n  height: auto;\n}\n\n.c-btn {\n  outline: none;\n  cursor: pointer;\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  width: auto;\n  height: 40px;\n  padding-left: 24px;\n  padding-right: 24px;\n  border-radius: 20px;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background-color: #F3B610;\n  color: #F8F8F8;\n  font-size: 15px;\n  font-weight: 500;\n  line-height: 15px;\n  -webkit-transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n}\n@media screen and (max-width: 767px) {\n  .c-btn {\n    padding-left: 14px;\n    padding-right: 14px;\n    font-size: 14px;\n  }\n}\n.c-btn:hover {\n  -webkit-transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out;\n  transition: box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out, color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n}\n.c-btn.c-btn--with {\n  border: 1px solid rgba(0, 0, 0, 0.75);\n  background-color: transparent;\n  color: #000000;\n}\n.c-btn[data-btn-size=full] {\n  width: 100%;\n}\n.c-btn[data-btn-color=gray] {\n  background-color: #F5F5F5;\n  color: #1A1A1A;\n}\n.c-btn[data-btn-color=gray]:hover {\n  background-color: #3A00FF;\n  color: #ffffff;\n}\n.c-btn[data-btn-color=blue] {\n  -webkit-box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0.3);\n          box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0.3);\n  background-color: #3A00FF;\n  color: #fff;\n}\n.c-btn[data-btn-color=blue]:disabled,\n.c-btn[data-btn-color=blue]:hover {\n  -webkit-box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0);\n          box-shadow: 0px 2px 8px 2px rgba(10, 149, 255, 0);\n  background-color: #F5F5F5;\n  color: #1A1A1A;\n}\n.c-btn[data-btn-fw=\"600\"] {\n  font-weight: 600;\n}\n.c-btn[data-btn-round=half] {\n  border-radius: 10px;\n}\n.c-btn + .c-btn {\n  margin-left: 12px;\n}\n.c-btn__wrapper {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.c-btn__wrapper--column {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n}\n.c-btn__wrapper--column .c-btn + .c-btn {\n  margin-left: 0;\n  margin-top: 12px;\n}\n.c-btn__wrapper--center {\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.c-btn__wrapper--between {\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n\n.header {\n  z-index: 999;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  background-color: rgba(4, 4, 30, 0.32);\n}\n.header__wrapper {\n  display: grid;\n  grid-template-columns: 300px 1fr 300px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  gap: 30px;\n  height: 90px;\n}\n@media screen and (max-width: 1279px) {\n  .header__wrapper {\n    grid-template-columns: 225px 1fr 225px;\n  }\n}\n@media screen and (max-width: 1023px) {\n  .header__wrapper {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-pack: justify;\n        -ms-flex-pack: justify;\n            justify-content: space-between;\n  }\n}\n.header__wrapper > div:nth-of-type(2) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n@media screen and (max-width: 1023px) {\n  .header__wrapper > div:nth-of-type(2) {\n    z-index: 999;\n    overflow: hidden;\n    overflow-y: auto;\n    position: fixed;\n    top: 90px;\n    left: 0;\n    display: none;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    width: 100%;\n    height: calc(100% - 90px);\n    padding: 50px;\n    background-color: #04041e;\n  }\n  .header__wrapper > div:nth-of-type(2).is-open {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n.header__wrapper > div:nth-of-type(3) {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n}\n@media screen and (max-width: 1023px) {\n  .header__wrapper > div:nth-of-type(3) {\n    gap: 15px;\n  }\n}\n.header__wrapper > div:nth-of-type(3) .hamburger {\n  display: none;\n}\n@media screen and (max-width: 1023px) {\n  .header__wrapper > div:nth-of-type(3) .hamburger {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n  }\n}\n.header__nav {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-column-gap: 50px;\n     -moz-column-gap: 50px;\n          column-gap: 50px;\n}\n@media screen and (max-width: 1279px) {\n  .header__nav {\n    -webkit-column-gap: 20px;\n       -moz-column-gap: 20px;\n            column-gap: 20px;\n  }\n}\n@media screen and (max-width: 1023px) {\n  .header__nav {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    gap: 30px;\n  }\n}\n.header__nav a {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  color: #F8F8F8;\n  font-size: 16px;\n  font-weight: 400;\n}\n@media screen and (max-width: 1023px) {\n  .header__nav a {\n    font-size: 20px;\n  }\n}\n\n.subscribe {\n  padding-top: 152px;\n  padding-bottom: 152px;\n}\n@media screen and (max-width: 767px) {\n  .subscribe {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n}\n.subscribe__box {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-direction: column;\n          flex-direction: column;\n  padding: 17px 26px;\n  border-radius: 8px;\n  border: 1px solid #EBEBEB;\n  text-align: center;\n}\n.subscribe__box-wrapper {\n  display: grid;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 10px;\n  padding-top: 54px;\n  padding-bottom: 24px;\n}\n@media screen and (max-width: 767px) {\n  .subscribe__box-wrapper {\n    grid-template-columns: 1fr;\n  }\n}\n.subscribe__box-title {\n  padding-bottom: 10px;\n  color: #1A1A1A;\n  font-size: 20px;\n  font-weight: 700;\n}\n.subscribe__box-desc {\n  padding-bottom: 15px;\n  color: rgba(26, 26, 26, 0.61);\n  text-align: center;\n  font-size: 12px;\n}\n.subscribe__box-subtitle {\n  padding-bottom: 15px;\n  color: #1A1A1A;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 700;\n}\n.subscribe__box-subtitle-wrapper > div {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n}\n.subscribe__box-subtitle-wrapper > div label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: start;\n      -ms-flex-align: start;\n          align-items: flex-start;\n  padding-top: 4px;\n  padding-right: 10px;\n}\n.subscribe__box-subtitle-wrapper > div > div {\n  -webkit-box-flex: 1;\n      -ms-flex: 1;\n          flex: 1;\n}\n.subscribe__box-subtitle + .subscribe__box-subtitle {\n  padding-top: 15px;\n  border-top: 1px solid #EBEBEB;\n}\n.subscribe__box-subtitle span {\n  color: rgba(26, 26, 26, 0.61);\n  text-align: center;\n  font-size: 12px;\n  font-weight: 400;\n}\n\n.sign {\n  padding-top: 152px;\n}\n@media screen and (max-width: 767px) {\n  .sign {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n}\n.sign__with .c-btn {\n  width: 100%;\n}\n.sign__with .c-btn img + span {\n  padding-left: 12px;\n}\n.sign__or {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-top: 24px;\n  padding-bottom: 24px;\n}\n.sign__or:before {\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n      -ms-transform: translateY(-50%);\n          transform: translateY(-50%);\n  left: 0;\n  width: 100%;\n  height: 1px;\n  background-color: rgba(0, 0, 0, 0.12);\n}\n.sign__or span {\n  z-index: 2;\n  position: relative;\n  background-color: #ffffff;\n  padding-left: 10px;\n  padding-right: 10px;\n}\n.sign__link {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  padding-top: 15px;\n}\n.sign__link a {\n  margin-left: 3px;\n  color: #3A00FF;\n}\n\n.check-your-email {\n  padding-top: 152px;\n  padding-bottom: 152px;\n}\n@media screen and (max-width: 767px) {\n  .check-your-email {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n}\n\n.thank-you {\n  padding-top: 152px;\n  padding-bottom: 152px;\n}\n@media screen and (max-width: 767px) {\n  .thank-you {\n    padding-top: 100px;\n    padding-bottom: 100px;\n  }\n}\n\n.statistics {\n  padding-top: 75px;\n  padding-bottom: 100px;\n}\n@media screen and (max-width: 767px) {\n  .statistics {\n    padding-top: 50px;\n    padding-bottom: 50px;\n  }\n}\n.statistics__wrapper-header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: end;\n      -ms-flex-pack: end;\n          justify-content: flex-end;\n  padding-bottom: 76px;\n  gap: 30px;\n}\n@media screen and (max-width: 767px) {\n  .statistics__wrapper-header {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    text-align: center;\n    padding-bottom: 50px;\n  }\n}\n.statistics__wrapper-footer {\n  padding-top: 76px;\n}\n@media screen and (max-width: 767px) {\n  .statistics__wrapper-footer {\n    padding-top: 50px;\n  }\n}\n.statistics__total {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.statistics__total p {\n  color: #ffffff;\n  font-size: 18px;\n}\n.statistics__total p strong {\n  font-weight: 700;\n}\n.statistics__date {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  max-width: 300px;\n}\n@media screen and (max-width: 767px) {\n  .statistics__date {\n    max-width: 100%;\n  }\n}\n.statistics__date label {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n.statistics__date label input {\n  outline: none;\n  position: relative;\n  width: 100%;\n  height: 32px;\n  padding: 9px;\n  border-radius: 8px;\n  border: none;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n  background: #fff;\n  color: #000000;\n  font-size: 14px;\n}\n.statistics__table {\n  padding: 10px;\n  border-radius: 12px;\n  background-color: rgba(255, 255, 255, 0.95);\n}\n@media screen and (max-width: 1599px) {\n  .statistics__table {\n    overflow: hidden;\n    overflow-x: auto;\n    position: relative;\n    width: calc(100% + 30px);\n    border-radius: 12px 0 0 12px;\n  }\n}\n.statistics__table table {\n  width: 100%;\n  max-width: 100%;\n  border-collapse: collapse;\n  background-color: transparent;\n}\n@media screen and (max-width: 1599px) {\n  .statistics__table table {\n    width: 1700px;\n    max-width: unset;\n  }\n}\n.statistics__table table tbody tr {\n  -webkit-transition: background-color 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out;\n}\n.statistics__table table tbody tr:hover {\n  background: rgba(0, 0, 0, 0.04);\n  -webkit-transition: background-color 0.3s ease-in-out;\n  transition: background-color 0.3s ease-in-out;\n}\n.statistics__table table tr th,\n.statistics__table table tr td {\n  vertical-align: middle;\n  text-align: left;\n  padding: 0.75rem;\n  color: #000;\n}\n.statistics__table table tr th {\n  border-bottom: 2px solid #dee2e6;\n  border-bottom-width: 2px;\n  font-weight: 600;\n  font-size: 15px;\n}\n.statistics__table table tr th.center {\n  text-align: center;\n}\n.statistics__table table tr td {\n  font-size: 14px;\n  border-bottom: 1px solid #dee2e6;\n}\n.statistics__table table tr td:first-of-type {\n  font-weight: 600;\n}\n.statistics__table table tr td a {\n  color: #3A00FF;\n}\n.statistics__table table tr td span {\n  display: block;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
